import { createApp } from 'vue'
import App from './App.vue'

const mountEl = document.querySelector('#user-profile')

if (mountEl) {
    const props = {
        username: mountEl.dataset.username,
        totalPresses: parseInt(mountEl.dataset.totalPresses, 10),
        totalTimeFormatted: mountEl.dataset.totalTimeFormatted,
        totalTimeClaimed: parseInt(mountEl.dataset.totalTimeClaimed, 10),
    }

    createApp(App, props).mount('#user-profile')
}
